const zh = {
  zh: "中文",
  en: "English",

  SAVE: "保存图片",

  home: "首页",
  onlineshow: "线上展厅",
  business: "企业专区",
  business1: "企业",
  artilce1: "资讯",
  exhibit: "展品",
  artilce: "行业资讯",
  contact: "联系我们",

  HOMEPAGE: "首页",
  PRODUCT: "线上展厅",
  COMPANY: "企业专区",
  INFORMATION: "行业资讯",
  CONTRACT: "联系我们",
  MEETING: "会议列表",
  EXHIBITOR: "参展商名单",

  "Search keywords...": "请输入公司名称、展位号",
  onlineAboutUs: "线上展概况",
  signInMajuscule: "登录/注册",
  console: "进入后台",
  joinFreeMajuscule: "注册",
  Hotline: "咨询热线",
  "For Suppliers": "卖家服务",
  "For Buyers2": "买家服务",
  Favorites: "我的收藏",
  Massage: "我的留言",
  Application: "参展报名",
  "Scan this": "扫码关注",
  Search: "搜索",
  "Search company or product or news…": "请输入展商名、关键词等",
  "Publish Transaction": "供需发布",
  Favorite: "收藏",
  Favorited: "已收藏",
  "Hot Products": "热门单品",
  Reservation: "预约",
  More: "更多",
  "Hotline:Working days，AM 9:00-PM 5:00": "咨询热线周一至周五 9:00-17:00",
  "Hotline:021-32513000": "咨询热线: 021-32513000",
  "21st floor, No.1678 Jinshajiang Road, Shanghai200333":
    "上海市金沙江路1678号21楼（绿洲中环大厦6号楼）",
  Subscription: "订阅",
  "Please Enter Your E-Mail！": "您的邮箱，以便接收电子快讯",
  Products: "全部",
  "All Company": "查看全部企业",
  Inquiry: "我要询盘",
  Inquiry1: "询盘",
  AddFavorites: "加入收藏 ",
  "Company Details": "公司详情",
  "Product Introduction": "产品简介",
  "Product Parameters": "产品参数",
  "Company Details2": "公司介绍",
  "Contact Information": "联系方式",
  "Product Name": "产品名称",
  "Product Color": "产品颜色",
  "Product Size": "产品尺寸",
  "Product Type": "产品型号",
  "Product Material": "产品材质",
  Recommendation: "相关产品推荐",
  "More Proudct…": "查看更多产品",
  "Business Content": "主营范围",
  "Share To": "分享至",
  "Reference Price": "参考价格",
  "Company Address": "公司地址",
  "Send Invitation": "我要预约",
  "Products List": "产品列表",
  "Find us in Exhibition": "展会图片",
  "Please leave your description so that the enterprise can confirm the reservation information with you!":
    "请详细描述您的需求，便于企业与您联系！",
  "Send Invitation2": "发送预约",
  "Contact Company": "联系企业",
  "Send Inquiry": "询盘内容",

  "Join Free": "注册",

  Latest: "最新",
  Default: "默认",
  Password: "展商登录",
  placeholder_password: "输入密码",
  placeholder_username: "展商登录",
  Mobile: "观众登录",
  "New User": "邮箱登录",
  "Join Free2": "立即注册",
  Verification: "通过验证",
  "Send Code": "获取验证码",
  "Verification Code": "输入验证码",
  "Auto Login Next Time": "下次自动登陆",
  "Sign In": "登录",
  "Forget Password": "忘记密码",
  Password2: "密码",
  "Complete Bikes": "自行车整车",
  Unicycles: "独轮车",
  Scooter: "滑板车",
  "Children's Vehicles": "童车",
  Trailers: "拖车",
  Bicycles: "自行车整车",
  "Folding Bicycles": "折叠车",
  "Frames,Forks & Parts": "车架、前叉及零件",
  "Tires,Rims & Parts": "轮胎、轮毂及零件",
  Seatpost: "鞍管",
  "Shock Absorbers,Suspension System": "避震器",
  Frames: "车架",
  "Head Parts": "车头组件",
  "Lugs & Shells ": "多通管",
  "Steel Ball Nest": "钢珠巢",
  "Front Forks": "前叉",
  "Rear Ends/Dropouts ": "前后叉端",
  "Spindle/Shaft ": "主轴组件/转轴组件",
  Tirefit: "补胎胶",
  "Repair Kits/Rubber Solutions": "补胎片",
  Valves: "阀/气门嘴",
  "Spokes & Nipples": "辐条",
  Hubs: "花鼓",
  Rims: "轮圈",
  Wheelset: "轮组",
  "Tires/Inner Tubes": "内外胎",
  "Plastic Wheels": "塑胶轮",
  "Transmissions & Parts": "传动零件",
  "Freewheels/Sprockets": "飞轮",
  Chains: "链条",
  "Chainwheels & Cranks": "曲柄组（牙盘、曲柄）",
  "Steering & Components": "操控零件组",
  Saddles: "鞍座",
  "Handlerbars & Stem": "把立/车手把",
  "Derailleur Gear Units": "变速器",
  Brakes: "刹车器",
  "Control Cables & Parts": "导线",
  Pedals: "脚踏板",
  Pegs: "脚踏杆",
  "Quick Release": "快拆",
  "Nuts & Bolts": "螺栓/螺帽",
  "Brake Pads": "刹车片",
  "Brake Line": "刹车线",
  Stems: "竖管",
  Accessories: "自行车配件",
  "Child Seat/Luggage Carriers ": "安全座椅/行李架/停车架",
  "Bells/Air Horns": "车铃/喇叭",
  "Reflectors/Back Mirrors": "反光片/后照镜",
  "Chain Covers/Fenders/Mudguards": "链盖/泥除",
  "Dynamo Lighting Sets/Battery Lighting ": "磨电灯/电池灯",
  "Locks/Alarms": "锁/报警器",
  "Bicycle Decals": "贴花/头牌",
  Painting: "涂料",
  Baskets: "网篮",
  "Grips/Tapes": "握把",
  "Machinery & Tools": "机械设备及工具",
  "Inspection Center": "检测中心",
  Tools: "辅助工具",
  Machinery: "机械设备",
  "Cycling/Outdoor Products": "骑行、户外用品",
  Bags: "包/袋",
  Pumps: "打气筒",
  "Cycle Computer": "码表",
  "Kettle Rack": "水壶架",
  Helmet: "头盔",
  "Carrying Frame": "携车架",
  "Sound/Electronic Products ": "音响/电子产品",
  "Gps Navigation": "GPS导航",
  "Non-Slip Elastic Band": "防滑松紧带",
  "Protecitve Gear": "护具",
  "Plus Material ": "面料",
  "Cycling Clothes": "骑行服",
  "Cycling Gloves": "骑行手套",
  "Riding Scarf/Mask": "骑行头巾/口罩",
  "Cycling Shoes": "骑行鞋/锁鞋",
  "Cycling Glasses": "骑行眼镜",
  "The Cycling Equipment": "骑行装备",
  "Lubricating Oil/Cleaning Agen": "润滑油/清洗剂",
  Kettle: "水壶",
  "Socks/Functional Socks": "袜子/压力袜",
  Camera: "运动摄像机",
  "Electric Bicycle / Motorcycle": "电动自行车及零配件",
  "Electric Bicycle": "电动自行车整车",
  "Electric Scooter": "电动滑板车",
  "Charger/Controller": "充电器/控制器",
  Battery: "电池",
  "Components & Parts Of E-Bike": "电动自行车零配件",
  Motors: "电机",
  "Detecting Equipment Of E-Bikes": "电动自行车检测设备",
  "Motor Cycle": "摩托车整车",
  "Motor Parts": "摩托车零配件",
  "Motor Cycle/Motor Parts": "摩托车及摩托车零配件",
  Miscellaneous: "综合类",
  Miscellaneous2: "综合类",
  Trader: "贸易商",
  "Media/Government": "媒体/政府机构",
  "Industry News": "行业动态",
  "Cyclist's Home": "骑行之家",
  "Industry Policy": "政策法规",
  "Industry History": "两轮故事",
  Video: "精彩视频",
  "Exhibition News": "展会动态",
  // "Products": "查看全部产品",
  "All Information": "查看更多",
  "Scan this to mobile website": "扫码进入线上展手机端",
  "Send Massage": "联系我们",
  "About Us": "展会概况",
  "For Buyers": "观众服务",
  "For Suppliers": "展商服务",
  "Media Cooperation": "媒体推广",
  "Online Exhibition": "网上展厅",
  Download: "下载中心",
  "Submit & Continue": "同意条款并注册",
  Hall: "公司所在馆",
  "Products List": "产品列表",
  "Join Free3": "注册会员",
  Homepage: "返回主页",
  "Sign in Now": "立即登陆",
  "Have an Account": "已有账号",

  "W1 International Brands": "W1 国际品牌馆",
  "W2 Bicycles & Accessories": "W2 整车及零配件馆",
  "W3 Children’s Bikes": "W3 童车馆",
  "E1 Bicycles": "E1 整车品牌馆",
  "E2 Accessories": "E2 零配件馆",
  "E3 Accessories": "E3 零配件馆",
  "E4 Cycling & Outdoor Sporting": "E4 户外骑行装备馆",
  "E5 Tires / E-bikes": "E5 轮胎馆/电动车及零配件馆",
  "E6 E-bikes & Accessories": "E6 电动车及零配件馆",
  "E7 E-bikes & Accessories": "E7 电动车及零配件馆",

  Exit: "退出",

  Liked: "已点赞",
  Like: "点赞",

  "Contact Us": "联系我们",
  "Product ... in total": "共{total}个产品",

  "Product Introduction 1": "产品描述",
  "Products Category": "产品类别",

  Name: "姓名",
  Company: "公司名称",
  "Job Title": "职务",
  "Country/Region": "国家/地区",
  Interest: "感兴趣项目",
  "Mobile/E-mail": "手机号/邮箱",
  "Confirm Password": "确认密码",
  "I Agree": "我已阅读并接受用户协议和隐私政策",
  "Please enter your Mobile or E-mail": "请输入您的手机号或是邮箱",
  "Send Code": "获取验证码",
  "Please drag the slider to the right side": "请滑动滑块完成验证",
  "Please enter your Name": "请输入您的姓名",
  "Please enter your Company": "请输入您所在的公司",
  "Please enter your Job Title": "请输入您的职务",
  "Verification Code2": "输入验证码",
  "Send To": "发送至",
  "Inquiry Product": "询价产品",
  "Inquired Quantity": "交易数量",
  "Estimated Order Time": "预计下单时间",
  Trade: "属性",
  Title: "供需标题",
  "Products Category2": "产品类别",
  "Delivery Period": "交易期限",
  "Trade Content": "需求描述",
  "Contact Information": "联系信息",
  "Plese Choose Inquired Quantity": "请选择询盘数量",
  "Your Company": "您所在的公司",
  Company1: "公司名称",
  "Publish Transaction2": "供需发布",
  "Contact ChinaCycle": "联系主办",
  "Contact Company2": "联系企业",
  "Your Name": "您的称呼",
  "Your Mobile": "您的联系电话",
  "Your E-mail": "您的邮箱",

  "Year/Month/Day": "年 / 月 /日",
  "Mr./Ms.": "您的称呼",
  "Your Phone": "您的联系电话",
  "Your E-mail": "您的邮箱",
  SUBMIT: "提交",
  Contact: "联系人",
  "Contact Title": "联系人职务",
  "Contact Phone": "联系电话",
  "Contact E-mail": "联系邮箱",
  "Company Website": "企业网址",
  "Company QRCode": "企业微信",
  Phone: "手机号",
  Username: "用户名",
  email: "邮箱",
  confirmPassword: "再次输入密码",
  "Company Type": "公司性质",
  "Please choose  your Company Type": "请选择贵公司性质",
  "Please enter your Password": "请输入密码",
  "Please enter your Password again": "请再次输入密码",
  "About Us Content":
    "中国国际自行车展览会线上展致力于打造全球自行车业界交流云平台，为广大参展商及观众提供全新的展览模式，并为线下展的成功举办提供强有力的支撑。通过双线融合，为参展商提供线上全年展示空间，也为专业买家搭建快速获取行业信息的资讯入口，借助线上平台加速供需双方达成贸易撮合。",
  ChinaCycle: "中国国际自行车线上展",
  Country: "请选择国家",
  Region: "请选择地区",
  "Please choose Products Category": "请选择产品类别",
  MeetingList: "会议列表",
  RecommendMeeting: "推荐会议",
  RecentMeeting: "近期会议",
  MeetingMore: "更多",
  readingMore: "阅读更多>>"
};
export default zh;



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js